export const getSearchParams = (url: string) => {
  // Create a params object
  let params = {} as Record<string, string>;

  new URL(url).searchParams.forEach(function (val, key) {
    params[key] = val;
  });

  return params;
};

export type SortablePayload = {
  index: number;
  containerId: string;
  items: string[];
};

export type LayoutLocator = { page: number; column: number; section: number };

export const parseLayoutLocator = (
  payload: SortablePayload | null,
): LayoutLocator => {
  if (!payload) return { page: 0, column: 0, section: 0 };

  const section = payload.index as number;
  const [page, column] = payload.containerId.split(".").map(Number);

  return { page, column, section };
};

export const moveItemInLayout = (
  current: LayoutLocator,
  target: LayoutLocator,
  layout: string[][][],
): string[][][] => {
  try {
    // Create a deep copy of the layout to avoid mutating the original array
    const newLayout = JSON.parse(JSON.stringify(layout)) as string[][][];

    // Get the item from the current location
    const item = newLayout[current.page][current.column][current.section];

    // Remove the item from the current location
    newLayout[current.page][current.column].splice(current.section, 1);

    // Insert the item at the target location
    newLayout[target.page][target.column].splice(target.section, 0, item);

    return newLayout;
  } catch (error) {
    return layout;
  }
};

export const isUrl = (string: string | null | undefined) => {
  if (!string) return false;

  const urlRegex = /https?:\/\/[^ \n]+/i;

  return urlRegex.test(string);
};

export const linearTransform = (
  value: number,
  inMin: number,
  inMax: number,
  outMin: number,
  outMax: number,
) => {
  if (inMax === inMin) return value === inMax ? outMin : NaN;
  return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
};

export const hexToRgb = (hex: string, alpha: number = 0) => {
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  } else {
    return `rgb(${r}, ${g}, ${b})`;
  }
};

export function formatPostalCodeWithPadding(postalCode?: number | string) {
  if (!postalCode) return "";
  let postalCodeStr = String(postalCode).padStart(7, "0");
  return postalCodeStr.slice(0, 3) + "-" + postalCodeStr.slice(3);
}
